import { render, staticRenderFns } from "./DriverSwiping.vue?vue&type=template&id=ff37327e&scoped=true&"
import script from "./DriverSwiping.vue?vue&type=script&lang=js&"
export * from "./DriverSwiping.vue?vue&type=script&lang=js&"
import style0 from "./DriverSwiping.vue?vue&type=style&index=0&id=ff37327e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff37327e",
  null
  
)

export default component.exports